import { DefaultSeoProps } from 'next-seo'
import { toAbsoluteUrl } from './routes'

const title = 'Diventa un supereroe della programmazione e trova lavoro'
const description =
    'Un sito innovativo per imparare a programmare, apprendere una nuova skill e trovare lavoro con la programmazione. Corsi di programmazione gratuiti per tutti i livelli e gli obiettivi.'

const config: DefaultSeoProps = {
    title: title,
    titleTemplate: '%s | Devv',
    description: description,
    themeColor: '#0A131E',

    additionalMetaTags: [
        { property: 'author', content: 'Matteo Giardino, matteo@devv.it' },
        { property: 'copyright', content: 'Matteo Giardino' },
        { property: 'abstract', content: description },
        { property: 'distribution', content: 'global' },
        { property: 'rating', content: 'general' },
        {
            property: 'keywords',
            content:
                'impara a programmare, corsi di programmazione gratis, diventare programmatore, creare siti web, creare applicazioni',
        },

        { name: 'application-name', content: 'Devv' },
        { name: 'medium', content: 'mult' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0' },
        { name: 'msapplication-TileColor', content: '#0A131E' },
        {
            name: 'msapplication-TileImage',
            content: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/apple-touch-icon.png',
        },

        { httpEquiv: 'content-type', content: 'text/html; charset=UTF-8' },
        { httpEquiv: 'x-ua-compatible', content: 'IE=Edge,Chrome=1' },
    ],

    additionalLinkTags: [
        {
            rel: 'manifest',
            href: '/site.webmanifest',
        },
        {
            rel: 'shortcut icon',
            type: 'image/x-icon',
            href: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/favicon.ico',
        },
        {
            rel: 'icon',
            type: 'image/x-icon',
            href: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/favicon.ico',
        },
        {
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
            href: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/favicon-16x16.png',
        },
        {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/favicon-32x32.png',
        },
        {
            rel: 'apple-touch-icon',
            type: 'image/png',
            sizes: '180x180',
            href: 'https://storage.googleapis.com/devv-public/brand-assets/favicon/apple-touch-icon.png',
        },
    ],

    openGraph: {
        type: 'website',
        locale: 'it_IT',
        url: 'https://devv.it/',
        siteName: 'Devv',
        title: title,
        description: description,
        images: [
            {
                url: `${toAbsoluteUrl(`/assets/og/default.png`)}`,
            },
        ],
    },

    twitter: {
        // handle: '@devv',
        site: '@devv.it',
        cardType: 'summary_large_image',
    },
}

export default config
